import Vue from 'vue';
import { AbstractModel } from '.';

class model extends AbstractModel {
    endpoint = 'participant-activities';

    loadNewParticipants = () => {
        return this.get({
            params: {
                limit: -1,
                'response-group': 'new_participant_activities',
                filter: [
                    {
                        type: 'eq',
                        field: 'isNew',
                        value: true,
                    },
                    {
                        type: 'eq',
                        field: 'organization',
                        value: Vue.$store.state.organization.selectedOrganizationID,
                    },
                ],
                'order-by': [
                    {
                        field: 'id',
                        direction: 'DESC',
                        type: 'field',
                    },
                ],
            },
        });
    };
}

export const ParticipantActivityModel = new model();
